
<script>
    export default {
       props : [
         'divCls'
        ,'cls'
        ,'value'
        ,'id'
        ,'name'
        ,'comCd'
        ,'dtlCdList'
        ,'valueProp'
        ,'textProp'
        ,'dummyCd'
        ,'dummyNm'
        ,'disabled'
        ,'excludes'
        ,'includes'
        ],
        template : `<div :class="divCls">
                        <select style="appearance:auto"
                                :class="cls"
                                v-model="this.value"
                                @change="bind($event.target.value)"
                                :id="id||comCd"
                                :name="name||comCd"
                                :disabled="isDisabled">
                            <option v-if="dummyNm" :value="dummyCd||''">{{dummyNm}}</option>
                            <option v-for="dtlCd in dtlCdList" :value="dtlCd[valueProp||'cd']" v-if="isVisible(dtlCd[valueProp||'cd'])">{{dtlCd[textProp||'nm']}}</option>
                        </select>
                    </div>`,
        computed : {
            isDisabled : function() {
                if(this.disabled === true) {
                    return true;
                }else if(this.disabled === false) {
                    return false;
                }else if(Array.isArray(this.disabled) && this.disabled.includes(this.name||this.comCd)) {
                    return true;
                }else{
                    return false;
                }
            }
        },
        methods : {
            isVisible : function(value) {
                if(this.excludes && this.excludes.includes(value)) {
                    return false;
                }
                if(this.includes && !this.includes.includes(value)) {
                    return false;
                }
                return true;
            },
            bind : function(value) {
                this.$emit('input', value);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/common/SelectBox.vue